var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSapBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 480,
    viewBox: "0 0 1440 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1298_5920)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 480,
    fill: "#1E0D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 358L482 478",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919 389L961 478",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.378 420.526C644.149 428.798 633.372 433.438 622.391 433.113C135.428 418.71 0 297 0 297V480H1440V297C1440 297 1320.88 418.774 817.608 433.125C806.636 433.437 795.852 428.8 788.629 420.534L787.498 419.24L774.969 404.902C745.881 371.617 694.119 371.617 665.031 404.902L651.378 420.526Z",
    fill: "url(#paint0_linear_1298_5920)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1362 395C1381.6 395.4 1433.5 391.167 1457 389L1504.5 418C1486.17 417.667 1432 412.6 1362 395Z",
    fill: "#1E0D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.76 449.432C1358.34 458.117 1407.13 476.321 1429.32 484.337L1460.02 530.762C1443.56 522.675 1396.67 495.089 1340.76 449.432Z",
    fill: "#1E0D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 395C65.9 395.4 14 391.167 -9.5 389L-57 418C-38.6667 417.667 15.5 412.6 85.5 395Z",
    fill: "#1E0D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.734 449.432C89.1585 458.117 40.3718 476.321 18.1753 484.337L-12.5169 530.762C3.94026 522.675 50.8304 495.089 106.734 449.432Z",
    fill: "#1E0D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.316 294.387L66.3164 437.387",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 209L95 263",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 297L1362 430",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299 223L1402 268",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1298_5920",
    x1: 720,
    y1: 503.5,
    x2: 720,
    y2: 297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155735,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0D12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1298_5920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 480,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapBanner);
export default __webpack_public_path__ + "static/media/sap_banner.1b96f411fb94a1a295f773eb98776dfe.svg";
export { ForwardRef as ReactComponent };